export const findUnwatchedRequiredVideo = (...videos) =>
  videos.find((video) => {
    // Must be a valid required video
    if (!video || !video.required || !video.video) {
      return false;
    }

    // The video must have no recorded view information
    // This prevents opening a required video for the same user repeatedly
    return !video.video.views;
  })?.video || null;

export const maybeCreateCategory = (
  title,
  videos,
  { expandLinkText, onExpandLinkClick } = {},
) => {
  if (!videos) {
    return [];
  }

  if (Array.isArray(videos)) {
    return videos.length > 0 ? [{ title, videos }] : [];
  } else if (videos.id == null) {
    return [];
  }

  return [{ title, videos: [videos], expandLinkText, onExpandLinkClick }];
};
